import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43f7e105"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "px-6 mt-8" };
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { wrapGrid } from 'animate-css-grid';
import { useRetroStore } from '@/pinia_stores/retro';
import transitions from '@/helpers/transitions';
import Group from '@/components/groups/Group.vue';
import NewGroup from '@/components/groups/NewGroup.vue';
import TopicBeingShared from '@/components/topics/TopicBeingShared.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Groups',
    setup(__props) {
        const retroStore = useRetroStore();
        const { groups, phase, isModerator, isCurrentUserPosting } = storeToRefs(retroStore);
        const orderedGroups = computed(() => {
            const orderByVotingPosition = (groups) => {
                return Array.from(groups).sort((g1, g2) => g1.number - g2.number);
            };
            const orderByFallbackCriteria = (groups) => {
                // TODO: We don't have a strong strategy to keep groups ordered in
                // this case
                return Array.from(groups).sort((g1, g2) => g1.id - g2.id);
            };
            if (['discussion', 'review', 'finished'].includes(phase.value)) {
                return orderByVotingPosition(groups.value);
            }
            else {
                return orderByFallbackCriteria(groups.value);
            }
        });
        onMounted(() => {
            const grid = document.querySelector('.animatedgrid');
            wrapGrid(grid);
        });
        const { fadeIn, fadeOut } = transitions.fade;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_TransitionGroup, {
                    css: false,
                    mode: "in-out",
                    tag: "ul",
                    class: "animatedgrid",
                    onEnter: _unref(fadeIn),
                    onLeave: _unref(fadeOut)
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderedGroups), (group) => {
                            return (_openBlock(), _createBlock(Group, {
                                key: group.id,
                                group: group
                            }, null, 8, ["group"]));
                        }), 128)),
                        (_unref(isCurrentUserPosting) || (_unref(phase) === 'grouping' && _unref(isModerator)))
                            ? (_openBlock(), _createBlock(NewGroup, { key: "new" }))
                            : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                }, 8, ["onEnter", "onLeave"]),
                _createVNode(TopicBeingShared)
            ]));
        };
    }
});
